import React from "react";
import { Content } from "../components/Content";
import { useWalletAssets } from "../hooks/useWalletAssets";

export const GoldMelted = () => {
  const { boxes } = useWalletAssets(3);

  return (
    <div className="px-4 sm:px-6 md:px-10">
      <Content boxes={boxes} id={15} pageName="طلای آب شده" />
    </div>
  );
};
